/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Consent_Text_After_LinkInputs */

const en_register_onboarding_personal_info_consent_text_after_link = /** @type {(inputs: Register_Onboarding_Personal_Info_Consent_Text_After_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const de_register_onboarding_personal_info_consent_text_after_link = /** @type {(inputs: Register_Onboarding_Personal_Info_Consent_Text_After_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gelesen.`)
};

/**
* | output |
* | --- |
* | "." |
*
* @param {Register_Onboarding_Personal_Info_Consent_Text_After_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_consent_text_after_link = /** @type {((inputs?: Register_Onboarding_Personal_Info_Consent_Text_After_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Consent_Text_After_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_consent_text_after_link(inputs)
	return en_register_onboarding_personal_info_consent_text_after_link(inputs)
});